import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, useTheme } from '@emotion/react';
import { IconLogo, IconContainer } from '../../Icon/index.js';
import { ErrorFallbackActionsGroup } from '../ActionsGroup/index.js';
import { MainContainer, IllustratedHeadGroup } from '../../Container/index.js';
export const ErrorFallback = props => {
    const { icon, mainTitle = 'Oops!', palette = 'light', title, description, navigation, children } = props;
    const theme = useTheme();
    const groupTitle = (_jsxs(_Fragment, { children: [_jsx("span", { "data-cy": "error-page-main-title", className: "error", children: mainTitle }), _jsx("br", {}), title] }));
    const Logo = Object.keys(theme).length && theme.secondaryLogo
        ? IconLogo[theme.secondaryLogo]
        : IconLogo.Logo;
    return (_jsxs("section", { "data-cy": "error-fallback", css: css({
            padding: '25px 0 50px',
            '@media screen and (min-width: 768px)': {
                padding: '50px 0'
            }
        }), children: [_jsx(IconContainer, { wrapperStyle: { display: 'flex', justifyContent: 'center' }, style: { width: '100%', height: 32, margin: '0 0 25px' }, ariaLabel: "logo", cy: "error-fallback-logo", children: _jsx(Logo, {}) }), _jsx(IllustratedHeadGroup, { role: "page", icon: icon, palette: palette, title: groupTitle, description: description }), children, _jsx(MainContainer, { children: _jsx(ErrorFallbackActionsGroup, { navigation: navigation }) })] }));
};
//# sourceMappingURL=index.js.map